import appConfig from "../app.json";

// get api version for mobile app
const apiVersion = appConfig.apiVersion;

// use apiBaseDev for development and apiBaseProd for production
export const apiBaseUrlVersionParam =
  process.env.NODE_ENV === "development"
    ? appConfig.apiBaseUrlDev
    : appConfig.apiBaseUrlProd;

export const apiBaseUrl = apiBaseUrlVersionParam.replace(
  "{apiVersion}",
  apiVersion
);
